import * as React from 'react';
import { useMemo } from 'react';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { TValidators } from '../../utils/useSimpleForm';
import { checkIsDigitCount, validatePrice } from './utils';
import { PRICE_VALUE_FIELD } from './constants';
import { TValue } from '../../utils/useSimpleForm/types/internal';
import { RawPriceQuestionContainer } from './RawPriceQuestionContainer';
import { EQuestionCode } from '../../types/form';

interface IPriceQuestionProps<T = TValue> extends IBaseQuestionProps {
  validators: TValidators<T>;
}
export const PriceQuestionContainer: React.FC<React.PropsWithChildren<IPriceQuestionProps>> = props => {
  const {
    question: { required, code },
  } = props;

  const validators = useMemo(() => {
    switch (code) {
      case EQuestionCode.PriceRange:
      case EQuestionCode.Price:
        return {
          [PRICE_VALUE_FIELD]: (value: string) => validatePrice(value, required, checkIsDigitCount(5)),
        };
      case EQuestionCode.PriceWithCommunal:
      case EQuestionCode.PriceRangeWithCommunal:
      case EQuestionCode.PriceRangeWithCommunalAndOperational:
        return {
          [PRICE_VALUE_FIELD]: (value: string) => validatePrice(value, required, checkIsDigitCount(3)),
        };
      default:
        return {
          [PRICE_VALUE_FIELD]: (value: string) => validatePrice(value, required),
        };
    }
  }, [code, required]);

  return <RawPriceQuestionContainer {...props} validators={validators} />;
};

PriceQuestionContainer.displayName = 'PriceQuestionContainer';
